// extracted by mini-css-extract-plugin
export var gif = "_cx-0";